module.exports = __webpack_public_path__ + "static/media/4622.d34d5472.jpg";